var map = {
	"./logo.png": 153,
	"./moss-side-jaguars-logo.svg": 726,
	"./player-photos/audry-shelford.png": 745,
	"./player-photos/bel-lopez.png": 62,
	"./player-photos/brooke-higgins.png": 714,
	"./player-photos/charlotte-russell.png": 81,
	"./player-photos/chelsea-ezeagba.png": 309,
	"./player-photos/chloe-magee.png": 831,
	"./player-photos/katie-white.png": 482,
	"./player-photos/kira-kalsi.png": 798,
	"./player-photos/louise-francois.png": 609,
	"./player-photos/maria-forson.png": 394,
	"./player-photos/placeholder.png": 823,
	"./player-photos/rhea-hackin.png": 691,
	"./player-photos/weronika-nycz.png": 255,
	"./player-photos/yuki-matsumoto.png": 542,
	"./player-photos/zoe-morrison.png": 26
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;